module.exports = __webpack_public_path__ + "static/media/algorithm_logo.0b7f5580.png";